import useDrawer, { openDrawers } from 'components/generic/Drawer/hooks/useDrawer';
import type { DrawerViewProps } from 'components/generic/Drawer/shared/types';
import useUncommittedSearchParams from '../../../../shared/hooks/useUncommittedSearchParams';
import { rootMenuId } from '../../../Filters/RootFilter/RootFilterMenu';
import { useSearchQuery } from '../../../Search/shared/hooks/useFilterOptionsBySearchQuery';

/**
 * A hook for interacting with Filter Menus
 * @param menuId
 * @returns
 */
export default function useFilterMenu(menuId: DrawerViewProps['id'], openRoot = true) {
    const { close } = useDrawer(menuId);
    const { resetUncommittedSearchParams } = useUncommittedSearchParams();
    const [, setSearchQuery] = useSearchQuery();

    const openFilterMenu = () => {
        // we need to keep track of the Url Search params before we opened the menu. We use it to revert if filters are changed but not applied.
        resetUncommittedSearchParams();
        setSearchQuery('');

        if (menuId === rootMenuId) {
            openDrawers([{ id: rootMenuId, props: {} }]);
            return;
        }

        // Always open the root menu first
        if (openRoot) {
            openDrawers([
                { id: rootMenuId, props: {} },
                { id: menuId, props: {} }
            ]);
        } else {
            openDrawers([{ id: menuId, props: {} }]);
        }
    };

    return { openFilterMenu, closeFilterMenu: close };
}
